import { Component, OnInit, Input, ViewEncapsulation } from '@angular/core';
import { SessionService } from '../../../core/services/session.service';

@Component({
  selector: 'i[illustration]',
  templateUrl: './illustration.component.html',
  styleUrls: ['./illustration.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class IllustrationComponent implements OnInit {
  @Input() illustration: string;
  source: string;

  constructor(private readonly session: SessionService) { }

  ngOnInit(): void {
    const prefix = this.session.getContextPrefix();
    this.source = 'assets/illustrations/' + prefix + '/' + this.illustration + '.svg';
  }
}
